import React, { useState } from 'react';
import { connect } from 'react-redux';
import DataGrid, { Column } from 'devextreme-react/data-grid';

export const WatchlistAddPortfolioLoanTable = ({ properties, onAddProperty }) => {
    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    const onActionCellRender = (e) => {
        return (
            <button
                id={'action_' + e.data.id}
                className='gridButton'
                title='Add Loan Property to Watchlist'
                onClick={(event) => onAddProperty(event, e.data.propertyId)}
                disabled={!e.data.canAddToWatchlist}
            >
                Add
            </button>
        );
    };

    const onCellPrepared = (e) => {
        if (e.rowType !== 'data') {
            return;
        }

        if (e.data.canAddToWatchlist) {
            e.cellElement.id = null;
        } else {
            e.cellElement.className = 'dx_portfolio_inactive';
        }
    };

    if (!properties || properties.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={properties}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'80%'}
            cellHintEnabled={true}
            onCellPrepared={onCellPrepared}
        >
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={120}
            />
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='propertyCity'
                caption='City'
                width={180}
            />
            <Column
                dataField='propertyState'
                caption='State'
                width={70}
            />
            <Column
                dataField='committed'
                caption='Committed'
                dataType='number'
                format='currency'
                width={90}
                alignment={'left'}
            />
            <Column
                alignment='center'
                cellRender={onActionCellRender}
                width={70}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
            />
        </DataGrid>
    );
};
